import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[hostInputNumber]'
})
export class InputNumberDirective {
  @Input() maxNumberLength = Number.POSITIVE_INFINITY;
  @Input() minNumber = 0;
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event) {
    const input = this.el.nativeElement;
    const value = input.value;
    input.value = value.replace(/[^\d]/g, '');
  }
}
